<script setup lang="ts">
import type { ContentSectionStoryblok } from "~/storyblok/.generated/component-types";

defineProps<{
  blok: ContentSectionStoryblok;
}>();
</script>

<template>
  <div class="content-section-container">
    <ContentSectionBlock
      :title="blok.title"
      :subtitle="blok.subtitle"
      :content="blok.content"
      :background-color="
        blok.backgroundColor !== '' ? blok.backgroundColor : 'platform-bg-1'
      "
      :desktop-content-direction="
        blok.desktopContentDirection !== ''
          ? blok.desktopContentDirection
          : 'column'
      "
      :text-align="blok.textAlign !== '' ? blok.textAlign : 'center'"
    />
  </div>
</template>

<style scoped lang="postcss">
.content-section-container {
  @apply relative w-full !px-0;
}
</style>
